import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { formatBusinessDate } from "utils/businessDate";

const formatLabel = (value) =>
  value
    ? value
        .split("_")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ")
    : "-";

const formatSaleDate = (date) => formatBusinessDate(date);

const formatCreatedAt = (date) =>
  date
    ? new Date(date).toLocaleString("en-US", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
    : "-";

const EXPORT_COLUMNS = [
  { header: "No.", key: "no" },
  { header: "Sale Date", key: "saleDate" },
  { header: "Product Name", key: "productName" },
  { header: "Qty", key: "qty" },
  { header: "Unit Price", key: "unitPrice" },
  { header: "Total Amount", key: "totalAmount" },
  { header: "Refund Amount", key: "refundAmount" },
  { header: "Status", key: "status" },
  { header: "Sale Type", key: "saleType" },
  { header: "Source", key: "source" },
  { header: "UTM Source", key: "utmSource" },
  { header: "Created At", key: "createdAt" },
];

const mapRow = (item, idx) => ({
  no: idx + 1,
  saleDate: formatSaleDate(item.saleDate),
  productName: item.productName || "-",
  qty: Number(item.qty || 0),
  unitPrice: Number(item.unitPrice || 0),
  totalAmount: Number(item.totalAmount || 0),
  refundAmount: Number(item.refundAmount || 0),
  status: formatLabel(item.status),
  saleType: formatLabel(item.saleType),
  source: formatLabel(item.source),
  utmSource: item.utm_source || "-",
  createdAt: formatCreatedAt(item.createdAt),
});

const escapeCsv = (value) => {
  const str = String(value ?? "");
  if (/[",\n\r]/.test(str)) return `"${str.replace(/"/g, '""')}"`;
  return str;
};

const fileDate = () => new Date().toISOString().slice(0, 10);

export const exportSalesToCsv = (rows) => {
  const mapped = rows.map(mapRow);
  const header = EXPORT_COLUMNS.map((c) => escapeCsv(c.header)).join(",");
  const body = mapped
    .map((row) => EXPORT_COLUMNS.map((c) => escapeCsv(row[c.key])).join(","))
    .join("\r\n");
  const blob = new Blob([`${header}\r\n${body}`], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, `Sales_Report_${fileDate()}.csv`);
};

export const exportSalesToExcel = async (rows) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sales");

  worksheet.columns = EXPORT_COLUMNS.map((col) => ({
    ...col,
    width: col.key === "productName" ? 25 : col.key === "createdAt" ? 22 : col.key === "utmSource" ? 18 : 15,
  }));

  rows.map(mapRow).forEach((row) => worksheet.addRow(row));

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    `Sales_Report_${fileDate()}.xlsx`
  );
};
